import DataGrid from '@app/components/organisms/DataGrid/DataGrid'
import Thumbnail from '@app/components/Thumbnail'
import { InertiaLink } from '@inertiajs/inertia-react'
import EditIcon from '@mui/icons-material/Edit'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton'
import { useTranslation } from 'react-i18next'

export default function CategoryIndex({ categories }) {
  const { t } = useTranslation()
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <DataGrid
          enableIndexColumn
          columns={[
            {
              id: 'name',
              Header: t('CATEGORIES.NAME'),
              accessor: 'name',
              type: 'string',
            },
            {
              id: 'thumbnail',
              Header: t('CATEGORIES.THUMBNAIL'),
              disableFilters: true,
              Cell: ({ row }) => <Thumbnail link={row.original.thumbnail?.link} />,
            },
            {
              id: 'background',
              Header: t('CATEGORIES.BACKGROUND'),
              disableFilters: true,
              Cell: ({ row }) => <Thumbnail link={row.original.background?.link} />,
            },
            {
              id: 'action',
              Header: t('CATEGORIES.ACTIONS'),
              disableFilters: true,
              align: 'center',
              cell: {
                style: { whiteSpace: 'nowrap' },
              },
              Cell: ({ row }) => (
                <IconButton component={InertiaLink} href={route('admin.categories.edit', row.original.id)}>
                  <EditIcon />
                </IconButton>
              ),
            },
          ]}
          data={categories}
          enableCollapseFilter={false}
          routeName="admin.categories.index"
        />
      </Grid>
    </Grid>
  )
}
